import React, { useMemo } from 'react';
import { Button, Table } from 'antd';
import suggestedStationsTableColumns from './suggestedStationsTableColumns';
import { useAuth } from '../../../contexts/userContext/userContext';
import { deleteSuggestedStation } from '../../../../services/admin/stationServices';
import useTranslation from '../../../hooks/translation/useTranslation';

function SuggestedStationsTable({ data, refetchData }) {
  const { trans } = useTranslation();
  const { ticketBookingOptions: { stations } } = useAuth();

  const stationsMap = useMemo(() => {
    const map = new Map();
    stations?.forEach((station) => {
      map.set(station.value, station.label_ka);
    });
    return map;
  }, [stations]);

  const handleDelete = async (id) => {
    await deleteSuggestedStation(id);
    refetchData();
  };

  return (
    <Table
      dataSource={data?.map((station) => ({
        ...station,
        name: stationsMap?.get(station?.station_code),
        delete: (
          <Button
            type="danger"
            onClick={() => handleDelete(station.id)}
          >
            {trans('delete')}
          </Button>
        ),
      }))}
      columns={suggestedStationsTableColumns.map(
        (col) => ({
          ...col,
          title: trans(col.title),
        }),
      )}
    />
  );
}

export default SuggestedStationsTable;
